import BundleModal from './components/BundleModal.vue';
import InitLazyComponent from 'Modules/InitLazyComponent';

const modals = document.querySelectorAll('.bundle-modal-source');
const initLazyComponent = new InitLazyComponent({
  selectors: modals,
  components: { BundleModal },
  template: '<BundleModal />',
});

initLazyComponent.init();
